module.exports = __webpack_public_path__ + "static/media/8.c558b78e.jpg";